import { navigate } from 'gatsby';
import React, { FC, useEffect } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import Button from '@ui/atoms/Button';
import HeadingText from '@ui/atoms/HeadingText';

import CenteredGridItem from '@ui/molecules/CenteredGridItem';

import spaced from '@ui/styled/Spaced';

import { IFlowStepComponentProps } from '@folx-types/flow-steps';

import theme from '@theme/FolxTheme';

export interface IImageUploadErrorStepPageContent {
	pageHeader: string;
	pageInfo: string;
	returnButton: string;
}

interface IImageUploadErrorStepProps extends IFlowStepComponentProps {
	pageContent: IImageUploadErrorStepPageContent;
}

const SpacedGridItem = spaced(CenteredGridItem);
const SpacedHeading = spaced(HeadingText);
const SpacedText = spaced(BasicText);

const ReturnContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	margin-bottom: ${theme.spacing.lg};

	${Button} {
		@media ${theme.responsive.breakpoints.tablet} {
			width: auto;
		}
	}
`;

const ImageUploadErrorStep: FC<IImageUploadErrorStepProps> = ({ pageContent }) => {
	const { pageHeader, pageInfo, returnButton } = pageContent;

	return (
		<SpacedGridItem marginTop="xxl">
			<SpacedHeading marginBottom="lg">{pageHeader}</SpacedHeading>
			<SpacedText marginBottom="xxl">{pageInfo}</SpacedText>
			<ReturnContainer>
				<Button
					onClick={() => {
						navigate(-1);
					}}
					label={returnButton}
				/>
			</ReturnContainer>
		</SpacedGridItem>
	);
};

export default ImageUploadErrorStep;
